module.exports = __webpack_public_path__ + "static/media/customer-2.e9b6e859.jpg";